<template>
  <div>
    <top-header-info :name="history"></top-header-info>
    <top-logo state="1"></top-logo>
    <!-- <right-nav></right-nav> -->
    <home-nav></home-nav>
    <div>
      <div class="w Pos-r">
        <div class="site-nav">
          <router-link :to="{ name: 'index' }">首页</router-link>>
          <router-link :to="{ name: 'user-center' }">个人中心</router-link>>
          订单详情
        </div>
        <left-userinfo state="3"></left-userinfo>
        <div class="right-refund-wrap">
          <div class="title">
            <h2>售后记录</h2>
          </div>
          <table class="order-detail-list-wrapper" cellspacing="0">
            <thead>
              <tr class="order-list-thead">
                <th style="width:330px !important;">商品名称</th>
                <!-- <th>包装清单</th> -->
                <th>购买时间</th>
                <th>购买数量</th>
              </tr>
            </thead>
            <tbody>
              <tr class="order-list-body">
                <td class="clearfix">
                  <img :src="orderInfo.product_image" alt="goods" />
                  <p>{{ orderInfo.name }}</p>
                </td>
                <!-- <td></td> -->
                <td>{{ orderInfo.created_at }}</td>
                <td>{{ orderInfo.quantity }}</td>
              </tr>
            </tbody>
          </table>
          <div class="remind">
            <span style="color:#FC0010">*温馨提示：</span>将由
            <span style="color:#01A8FD">上班族</span>
            为您提供售后服务，根据您填写的信息客服人员会为您提供 售后服务，
            具体信息将在您提交售后服务单成功，感谢您的支持与信任！
          </div>

          <div class="write-wrap">
            <el-row>
              <el-col :span="3">
                <span class="star">*</span> 服务类型：
              </el-col>
              <el-col :span="20" class="service-wrap">
                <span
                  :class="{ actived: item.code === reason && firstClick }"
                  v-for="item in service_types"
                  :key="item.code"
                  @click="(reason = item.code), (firstClick = true)"
                  >{{ item.name }}</span
                >
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="3">
                <span class="star">*</span> 提交数量：
              </el-col>
              <el-col :span="20">
                <el-input-number
                  size="small"
                  v-model="num"
                  :min="minQuality"
                  :max="maxQuality"
                ></el-input-number>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="3">
                <span class="star">*</span> 问题描述：
              </el-col>
              <el-col :span="20">
                <el-input
                  type="textarea"
                  placeholder="请在此详细描述您的售后问题并点击选择下方快捷标签"
                  :autosize="{ minRows: 3, maxRows: 6 }"
                  v-model="content"
                ></el-input>
                <ul class="quickInput">
                  <li
                    v-for="(item, index) in quickInputArr"
                    :key="index"
                    :class="item.isActive ? 'active' : ''"
                    @click="clickQuickInput(item)"
                  >
                    {{ item.value }}
                  </li>
                </ul>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="3">
                <span class="star">&nbsp;&nbsp;</span>
              </el-col>
              <el-col :span="20">
                <div class="img-show">
                  <div
                    v-for="(item, index) in imgDataUrl"
                    :key="index"
                    class="img-wraper"
                  >
                    <img :src="item" alt="pic" />
                    <span class="oclose" @click="delImage(index)">X</span>
                  </div>
                  <div
                    class="img-wraper file-upload"
                    v-show="imgDataUrl.length < 5"
                  >
                    <input
                      type="file"
                      name="file"
                      @change="uploadImg"
                      accept=".jpg, .jpeg, .png, .gif, .bmp"
                    />
                    <i class="el-icon-plus"></i>
                  </div>
                </div>

                <div class="hint-txt">
                  为了帮助您更好的解决问题，请上传图片。最多可上传5张图片，每张图片大小不超过5M，支持bmp,gif,jpg,png,jpeg
                </div>
              </el-col>
            </el-row>
          </div>
          <div
            class="jd-write"
            v-if="returnWays.length > 0 && this.reason !== '40'"
          >
            <el-row>
              <el-col :span="3">
                <span class="star">*</span> 返回方式：
              </el-col>
              <el-col :span="20" class="service-wrap">
                <span
                  :class="{ actived: item.code == returnway }"
                  v-for="item in returnWays"
                  :key="item.code"
                  @click="returnway = item.code"
                  >{{ item.name }}</span
                >
              </el-col>
            </el-row>
            <!-- 取货地址 -->
            <el-row v-if="returnway == '4'">
              <el-col :span="3">
                <span class="star">*</span> 取货地址：
              </el-col>
              <address-select :address="fetch_address"></address-select>
              <el-col :span="3">&nbsp;</el-col>
              <div style="color:#E2333F">该地址是快递员上门取件的地址</div>
            </el-row>
          </div>
          <div class="jd-write" v-if="reason !== '10'">
            <!-- 收货地址 -->
            <el-row>
              <el-col :span="3">
                <span class="star">*</span> 收货地址：
              </el-col>
              <address-select :address="address"></address-select>
              <el-col :span="3">&nbsp;</el-col>
              <div style="color:#E2333F">该地址是供应商回寄给您的地址</div>
            </el-row>
          </div>
          <el-button class="sunmit-btn" @click="submit">确认提交</el-button>
        </div>
      </div>

      <div class="mask_wrap" v-show="showMask">
        <div>
          <el-row class="mask_title">
            <el-col :span="23">
              <p>
                <img
                  src="../../assets/images/success.png"
                  alt="ok"
                  align="center"
                />
                您的申请已提交成功！如紧急请主动联系客服：400-088-8635
              </p>
            </el-col>
            <el-col :span="1"> </el-col>
          </el-row>
          <el-row class="mask_info">
            <el-col :span="12">
              <img :src="orderInfo.product_image" alt="goods" />
            </el-col>
            <el-col :span="12">
              <div class="goods_title">{{ orderInfo.name }}</div>
              <ul>
                <li>
                  <span>退换/售后编号</span>
                  {{ workorderInfo.workorder_id }}
                </li>
                <li>
                  <span>订单编号</span>
                  {{ workorderInfo.order_id }}
                </li>
                <li>
                  <span>申请时间</span>
                  {{ workorderInfo.date_added }}
                </li>
                <li>
                  <span>数量</span>
                  x
                  {{ workorderInfo.quantity }}
                </li>
              </ul>
            </el-col>
          </el-row>
          <el-row class="mask_button">
            <el-col :span="24">
              <router-link
                :to="{ name: 'refund-list' }"
                @click="showMask = false"
                replace
                >确 认</router-link
              >
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <bottom-content></bottom-content>
  </div>
</template>
<script>
import TopHeaderInfo from "@/components/top-header-info";
import TopLogo from "@/components/top-logo";
import RightNav from "@/components/right-nav";
import BottomContent from "@/components/bottom-content";
import HomeNav from "@/components/home-nav";
import LeftUserinfo from "@/components/left-userinfo";
import { mixinUpload } from "@/assets/js/imgUpload";
import addressSelect from "./components/address-select.vue";
export default {
  components: {
    TopHeaderInfo,
    TopLogo,
    RightNav,
    BottomContent,
    HomeNav,
    LeftUserinfo,
    addressSelect
  },
  data() {
    return {
      history: "history",
      firstClick: false, // 首次进入页面服务类型默认不选择
      orderInfo: "",
      service_types: "",
      minQuality: 0,
      maxQuality: 0,
      num: 0,
      content: "",
      imgDataUrl: [],
      reason: "",
      showMask: false,
      returnWays: [],
      returnway: "",
      workorderInfo: "",
      fetch_address: {},
      address: {},
      quickInputArr: [
        { isActive: false, value: "长时间未收到商品，不要了" },
        { isActive: false, value: "我要催发货" },
        { isActive: false, value: "物流显示已签收，但实际未收到" },
        { isActive: false, value: "未查询到物流信息" },
        { isActive: false, value: "物流停滞" },
        { isActive: false, value: "收到的商品数量与下单不符" },
        { isActive: false, value: "商品破损/功能缺失" },
        { isActive: false, value: "服饰/鞋类尺码不合适" }
      ]
    };
  },
  watch: {
    content(value) {
      this.quickInputArr.forEach(item => {
        item.isActive = value.indexOf(`${item.value}，`) > -1 ? true : false;
      });
    }
  },
  mixins: [mixinUpload],
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      const id = this.$route.params.product_id;
      this.$reqGet("api/store/workorder/supportedservice/" + id).then(res => {
        this.service_types = res.data.data.service_types;
        this.reason = this.service_types[0].code;
        this.$reqGet("api/store/order/product/" + id).then(res => {
          this.orderInfo = res.data.data;
          if (this.orderInfo.quantity === 1) {
            this.minQuality = 1;
            this.num = 1
          }
          this.address = {
            name: this.orderInfo.shipping_name,
            phone: this.orderInfo.shipping_phone,
            zone: {
              name: this.orderInfo.zone,
              id: this.orderInfo.zone_id
            },
            city: {
              name: this.orderInfo.city,
              id: this.orderInfo.city_id
            },
            area: {
              name: this.orderInfo.area,
              id: this.orderInfo.area_id
            },
            town: {
              name: this.orderInfo.town,
              id: this.orderInfo.town_id
            },
            address: this.orderInfo.shipping_address
          };
          this.fetch_address = { ...this.address };
          this.getReturnWay();
        });
      });
      this.$reqGet("api/store/workorder/workordernumber/" + id).then(res => {
        this.maxQuality = res.data.data.quantity;
      });
    },
    uploadImg(e) {
      this.getTokenMessage(e.target.files[0], key => {
        this.imgDataUrl.push(key);
      });
    },
    //图片删除
    delImage(index) {
      this.imgDataUrl.splice(index, 1);
    },
    getReturnWay() {
      return this.$reqGet(
        "api/store/workorder/returnways/" + this.$route.params.product_id
      ).then(res => {
        this.returnWays = res.data.data.return_ways;
        //默认设置返回方式
        let defaultReturnway = "";
        res.data.data.return_ways.forEach(item => {
          if (item.name === "上门取件") {
            this.returnway = item.code;
          } else if (item.name === "客户发货") {
            defaultReturnway = item.code;
          }
        });
        if (!this.returnway) {
          this.returnway = defaultReturnway
            ? defaultReturnway
            : this.returnWays[0].code;
        }
      });
    },
    submit() {
      if (this.reason && !this.firstClick) {
        this.$message.error("请选择服务类型");
        return;
      }
      if (!this.num) {
        this.$message.error("请输入提交数量");
        return;
      }
      if (!this.content) {
        this.$message.error("请输入售后描述");
        return;
      }
      let obj = {
        order_product_id: this.$route.params.product_id,
        num: this.num,
        service_code: this.reason,
        remark: this.content,
        images_code: this.imgDataUrl,
        pick_type: this.returnway
      };

      if (this.reason !== "10") {
        obj.return_zone_code = this.address.zone.id;
        obj.return_city_code = this.address.city.id;
        obj.return_area_code = this.address.area.id;
        obj.return_town_code =
          (this.address.town && this.address.town.id) || null;
        obj.return_address = this.address.address;
        obj.contact_name = this.address.name;
        obj.telephone = this.address.phone;
      }

      if (this.returnway == "4") {
        obj.pick_zone_code = this.fetch_address.zone.id;
        obj.pick_city_code = this.fetch_address.city.id;
        obj.pick_area_code = this.fetch_address.area.id;
        obj.pick_town_code =
          (this.fetch_address.town && this.fetch_address.town.id) || null;
        obj.pick_address = this.fetch_address.address;
        obj.contact_name = this.fetch_address.name;
        obj.telephone = this.fetch_address.phone;
      }
      if (
        this.returnWay === "4" &&
        this.reason !== "10" &&
        this.address.phone !== this.fetch_address.phone
      ) {
        this.$message.error("两个地址手机号不同，请重新选择");
        return;
      }
      if (this.orderInfo.supplier === "wangyi" && this.reason === "10") {
        this.$confirm("请确保您已收到该商品，如已收到请点击确认收货", {
          confirmButtonText: "确认收货",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.$reqPost("api/store/order/confirmReceipt", {
            manufacturer_id: this.orderInfo.manufacturer_id,
            order_product_id: this.$route.params.product_id
          }).then(res => {
            if (res.data.success) {
              return this.$reqPost("api/store/workorder", obj).then(res => {
                if (res.data.data.result) {
                  this.showMask = true;
                  this.workorderInfo = res.data.data.workorder;
                }
              });
            } else {
              return;
            }
          });
        });
      } else {
        this.$reqPost("api/store/workorder", obj).then(res => {
          if (res.data.data.result) {
            this.showMask = true;
            this.workorderInfo = res.data.data.workorder;
          }
        });
      }
    },
    // 点击快捷输入
    clickQuickInput(item) {
      item.isActive = item.isActive ? false : true;
      this.content = item.isActive
        ? this.content.concat(item.value, "，")
        : this.content.replace(`${item.value}，`, "");
    }
  }
};
</script>

<style lang="less" scoped>
.big_wrap {
  height: 100vh;
  overflow: hidden;
}
.site-nav {
  padding: 20px 0;
  color: #999;
  font-size: 16px;
  a {
    color: #999;
  }
  a:first-child {
    color: #444;
  }
}
.right-refund-wrap {
  // position: relative;
  margin-bottom: 40px;
  min-height: 572px;
  width: 980px;
  margin-left: 220px;
  box-sizing: border-box;
  padding: 10px 25px 0;
  background-color: #fff;
  .title {
    line-height: 42px;
    height: 42px;
    border-bottom: 2px solid #dadada;
    margin-bottom: 30px;
    h2 {
      width: 120px;
      border-bottom: 2px solid #e2333f;
      font-size: 20px;
      font-weight: normal;
      margin: 0;
      box-sizing: border-box;
      padding-left: 20px;
    }
  }
  .order-detail-list-wrapper {
    width: 100%;
    color: #222;
    text-align: center;
    .order-list-thead {
      background-color: #fbfbfb;
      height: 40px;
      line-height: 40px;
      border: 1px solid #f5f5f5;
    }
    .order-list-body {
      td {
        border: 0.5px solid #f5f5f5;
      }
      td:first-child {
        padding: 10px;
        text-align: left;
      }
      img {
        width: 60px;
        height: 60px;
        margin-top: 10px;
      }
      p {
        margin-left: 80px;
        margin-top: -65px;
        display: -webkit-box;
        height: 58px;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
    }
    .red_word {
      color: #e2333f;
    }
  }
  .remind {
    line-height: 30px;
    margin-top: 20px;
  }
  .write-wrap {
    width: 930px;
    min-height: 460px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid #eeeeee;
    margin: 20px auto;
    padding: 20px 30px;
    box-sizing: border-box;
    .el-row {
      line-height: 54px;
      .star {
        color: #e2333f;
      }
      .el-textarea {
        margin: 18px 0;
      }
      .quickInput {
        display: flex;
        flex-wrap: wrap;
        margin: -10px 5px 18px;
        line-height: 1;
        li {
          padding: 5px 8px;
          border-radius: 10px;
          margin-right: 20px;
          margin-bottom: 10px;
          border: 1px solid #ccc;
          cursor: pointer;
          color: #333;
          &.active {
            border-color: #e2343f;
          }
        }
      }
      .service-wrap {
        > span {
          display: inline-block;
          height: 32px;
          line-height: 32px;
          padding: 0px 10px;
          background: rgba(255, 255, 255, 1);
          border: 1px solid rgba(218, 218, 218, 1);
          margin-right: 10px;
          cursor: pointer;
          &.actived {
            border: 1px solid #e2333f;
            color: #e2333f;
          }
        }
      }
      .hint-txt {
        font-size: 14px;
        color: #cccccc;
        line-height: normal;
        display: inline-block;
        white-space: nowrap;
      }

      .img-show {
        line-height: normal;
        display: flex;
        .file-upload {
          background: #f5f5f5;
          display: flex;
          align-items: center;
          justify-content: center;
          input {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            z-index: 100;
            opacity: 0;
            width: 100%;
            height: 100%;
            cursor: pointer;
          }
          .el-icon-plus {
            color: #bbbbbb;
            font-size: 50px;
          }
        }
      }
      .img-show > .img-wraper,
      .van-uploader {
        position: relative;
        width: 120px;
        height: 120px;
        box-sizing: content-box;
        border: 1px solid #ddd;
        margin-right: 5px;
      }
      .img-show > div > img {
        width: 100%;
        height: 100%;
      }
      .oclose {
        position: absolute;
        top: 0;
        right: 0;
        width: 15px;
        height: 15px;
        text-align: center;
        font-size: 12px;
        line-height: 15px;
        color: #fff;
        background-color: rgba(1, 1, 1, 0.2);
        cursor: pointer;
      }
    }
  }
  .jd-write {
    border: 1px solid #dadada;
    margin: 20px auto;
    padding: 20px 30px;
    box-sizing: border-box;
    .el-row {
      line-height: 54px;
      .star {
        color: #e2333f;
      }
      .user-input {
        width: 360px;
      }
      .service-wrap {
        > span {
          display: inline-block;
          height: 32px;
          line-height: 32px;
          padding: 0px 10px;
          background: rgba(255, 255, 255, 1);
          border: 1px solid rgba(218, 218, 218, 1);
          margin-right: 10px;
          cursor: pointer;
          &.actived {
            border: 1px solid #e2333f;
            color: #e2333f;
          }
        }
      }
    }
  }
  .sunmit-btn {
    width: 160px;
    height: 48px;
    line-height: 48px;
    background: rgba(226, 51, 63, 1);
    border-radius: 5px;
    font-size: 16px;
    color: #fff;
    padding: 0;
    margin-bottom: 30px;
  }
}
.mask_wrap {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  background: rgba(1, 1, 1, 0.6);
  > div {
    position: fixed;
    width: 900px;
    height: 450px;
    padding: 0 15px;
    background: rgba(255, 255, 255, 1);
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .mask_title {
    text-align: center;
    font-size: 26px;
    margin: 10px 20px;
    color: #333;
    border-bottom: 1px solid #bbb;
    img {
      width: 40px;
    }
    i {
      color: #666;
      cursor: pointer;
    }
  }
  .mask_info {
    > div:first-child {
      text-align: center;
      img {
        width: 190px;
        height: 190px;
        margin-top: 20px;
      }
    }
    .goods_title {
      font-size: 20px;
      color: rgba(0, 0, 0, 1);
      line-height: 30px;
      margin-bottom: 10px;
    }
    li {
      color: #222;
      line-height: 30px;
      span {
        display: inline-block;
        width: 100px;
        margin-right: 10px;
        color: #999;
        text-align-last: justify;
      }
    }
  }
  .mask_button {
    padding: 30px 150px;
    text-align: center;
    a {
      display: inline-block;
      width: 300px;
      height: 40px;
      line-height: 40px;
      color: #fff;
      font-size: 16px;
      background: rgba(226, 51, 63, 1);
      border-radius: 5px;
    }
  }
}
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  border-color: #e2333f;
  background-color: #e2333f;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #e2333f;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/refund-submit.vue